var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_32",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8_32",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACM0lEQVR4nO3Yy6tNcRjG8Z/kKLcMUHKOSEaS3EtiJilMlZEkwp+gxEAiihiciYFbMpDLxMSEpAwoohTlMkHHEXINH/14aad99oXNWqfWt3Z7t97n/e332Ws967JTqqj4P2A6DuAu3sTrFnZjUhoMYB3eG5hXWJnKDJbgC77iGBZiLMZgLo5E7QNmprKCi/Gr72yg2Rua06ms4GUMOaGBZnJonqeyghcxZHcDTXdo+lJZwZkYcl8DzZ7QnEtlBbPijJUDfaIm7MMxJ7bl2mcsSGUGy2sOsXq8w9o0GMA4bMPVHOq4IN7Gfkwter6KQYcfh1KrXOlEL4ZhBQ7hOp7EnUM/7uAk1mBUO0ba4m96MQQb8LBF/VNswtCWjfyJrt1eXKr5fA/bsRQT0RWn/RnY+tvevoCRZTKSuY/VzXoyWIVn0XctX9tSwUY+hfQ4RjfT14JpeBD9B4s2shFbckaaaeuB2XEyyHcYiwoz0gmwI77ubMsDltTIOLyNh8ApLQ34r4zkAdAb142cm8c4jJ4W+0/FV64vzAiW4bX69GNxC2tsDv3RQozkm84aE+cwL18X4v18bO/D+CbrZH3mRlFGen+aGKB+Puq7mqzTE7pHRRnJmcjMHaA+P+o3m6wzInRvizKSny4zXQPUu6L+8U/m+J9Gmur87VqVkVTtkbqoDq2gykiqMlIXVUaCKiOpykhdVBkJqoykkmakVTrV28k5vpP/JW+j/3Knen9HB9eqqKhIv/gGiT7yI4dMxCoAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1dcc03681f994bee2cd4580fcd7e870b.svg";
export { ForwardRef as ReactComponent };